import type { ReactNode } from 'react';

export interface PageHeaderProps {
  /** Page title. Pass a string, or markup like <>Home - <span className="fw-normal">Dashboard</span></>. */
  title: ReactNode;
  /** Right-side content of the title row (e.g. a customer switcher / avatars). */
  actions?: ReactNode;
  /** Breadcrumb element (e.g. <Breadcrumb/>) — renders the second row. */
  breadcrumb?: ReactNode;
  /** Right-side content of the breadcrumb row (the header menu: Support, Settings…). */
  secondaryActions?: ReactNode;
  /** Stick to the top of the scrolling content area as the page scrolls. Defaults to true. */
  sticky?: boolean;
  className?: string;
}

/** Limitless page header: a title row plus an optional breadcrumb row, each with a menu slot. */
export function PageHeader({
  title,
  actions,
  breadcrumb,
  secondaryActions,
  sticky = true,
  className = '',
}: PageHeaderProps) {
  return (
    <div
      className={`page-header page-header-light shadow ${className}`.trim()}
      style={sticky ? { position: 'sticky', top: 0, zIndex: 1020 } : undefined}
    >
      <div className="page-header-content d-lg-flex">
        <div className="d-flex">
          <h4 className="page-title mb-0">{title}</h4>
        </div>
        {actions && (
          <div className="d-lg-block my-lg-auto ms-lg-auto">
            <div className="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">{actions}</div>
          </div>
        )}
      </div>

      {(breadcrumb || secondaryActions) && (
        <div className="page-header-content d-lg-flex border-top">
          <div className="d-flex">{breadcrumb}</div>
          {secondaryActions && (
            <div className="d-lg-block ms-lg-auto">
              <div className="d-lg-flex mb-2 mb-lg-0">{secondaryActions}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
